module.exports = __webpack_public_path__ + "img/cat2.24e0ccef.svg";